// extracted by mini-css-extract-plugin
export default {"bottomDrawer":"bottomDrawer___VAFZt","contentCrateDrawer":"contentCrateDrawer___rgHsE"};